import _classCallCheck from '@babel/runtime/helpers/classCallCheck';
import _createClass from '@babel/runtime/helpers/createClass';
import axios from 'axios';
import qs from 'qs';
import icons from '../core/icons';
var Interaction = function () {
    function Interaction(player) {
        _classCallCheck(this, Interaction);
        this.player = player;
        this.NULL_INDEX = -1;
        this.currentMarker = {};
        this.currentMarkerIndex = this.NULL_INDEX;
        this.newMarkerIndex = this.NULL_INDEX;
        this.initHighlightBlur();
        this.getHighlightData();
        this.initHighlights();
        this.highlightListener();
    }
    _createClass(Interaction, [
        {
            key: 'initHighlightBlur',
            value: function initHighlightBlur() {
                this.highlightEl = document.createElement('div');
                this.highlightEl.classList.add('yplayer-shade');
                this.highlightEl.classList.add('yplayer-shade-hide');
                document.body.append(this.highlightEl);
            }
        },
        {
            key: 'getHighlightData',
            value: function getHighlightData() {
                var res = [
                    {
                        time: 3,
                        text: '这是第 3 秒',
                        question: [{
                                'questionUuid': '7182603af59251699019e199d4f9fe1c',
                                'questionTitleUuid': '',
                                'subjectId': 2,
                                'qForms': 2,
                                'questionType': 1,
                                'showType': '1',
                                'difficulty': 50,
                                'translationId': 0,
                                'estimatesTime': 90,
                                'score': 0,
                                'priority': 0,
                                'translation': '',
                                'articleTitle': '',
                                'content': {
                                    'content': '实数b满足|b|\uFF1C3\uFF0C并且有实数a\uFF0C且a\uFF1Cb恒成立\uFF0Ca的取值范围是(\xA0\xA0 )',
                                    'type': 1,
                                    'showType': 1,
                                    'image': [],
                                    'hearing': [],
                                    'video': []
                                },
                                'options': [
                                    {
                                        'content': '小于或等于3的实数',
                                        'hearing': [],
                                        'image': [],
                                        'key': 'A',
                                        'reason': [],
                                        'showType': 1,
                                        'type': 3,
                                        'video': []
                                    },
                                    {
                                        'content': '小于3的实数',
                                        'hearing': [],
                                        'image': [],
                                        'key': 'B',
                                        'reason': [],
                                        'showType': 1,
                                        'type': 3,
                                        'video': []
                                    },
                                    {
                                        'content': '小于或等于\uFE633的实数',
                                        'hearing': [],
                                        'image': [],
                                        'key': 'C',
                                        'reason': [],
                                        'showType': 1,
                                        'type': 3,
                                        'video': []
                                    },
                                    {
                                        'content': '小于\uFE633的实数',
                                        'hearing': [],
                                        'image': [],
                                        'key': 'D',
                                        'reason': [],
                                        'showType': 1,
                                        'type': 3,
                                        'video': []
                                    }
                                ],
                                'answer': 'A',
                                'analyze': [{
                                        'title': '熟悉绝对值的意义\uFF0C根据绝对值的意义求得b的取值范围\uFF0C再根据a\uFF0Cb的关系求得a的取值范围\uFF0E',
                                        'content': []
                                    }],
                                'prompt': [],
                                'hearReading': '',
                                'articleSource': '',
                                'wordSize': 0,
                                'questionSource': [],
                                'questionTypeName': '单选题',
                                'usedType': [{
                                        'tagId': 441,
                                        'tagCode': '1',
                                        'tagName': '1.练习题',
                                        'position': 441
                                    }],
                                'module': [
                                    {
                                        'tagId': 493,
                                        'tagCode': '5',
                                        'tagName': '5.招生抓手',
                                        'position': 493
                                    },
                                    {
                                        'tagId': 495,
                                        'tagCode': '7',
                                        'tagName': '7.高效学习',
                                        'position': 495
                                    },
                                    {
                                        'tagId': 495,
                                        'tagCode': '7',
                                        'tagName': '7.高效学习',
                                        'position': 495
                                    },
                                    {
                                        'tagId': 495,
                                        'tagCode': '7',
                                        'tagName': '7.高效学习',
                                        'position': 495
                                    }
                                ],
                                'factors': [
                                    {
                                        'tagId': 2024,
                                        'tagCode': 'gsn50',
                                        'tagName': '数感直觉能力',
                                        'position': 2024
                                    },
                                    {
                                        'tagId': 2026,
                                        'tagCode': 'gsn52',
                                        'tagName': '推理能力',
                                        'position': 2026
                                    }
                                ],
                                'knowledge': [{
                                        'tagId': 21475,
                                        'tagCode': 'c050203',
                                        'tagName': '实数的性质',
                                        'position': 21475
                                    }],
                                'reason': [],
                                'thoughts': [],
                                'methods': [],
                                'knowledgeVice': [],
                                'midFinalTerm': [],
                                'prefer': []
                            }]
                    },
                    {
                        time: 30,
                        text: '这是第 30 秒',
                        question: [{
                                'questionUuid': 'a954b4df1fd1a250c63d7a7ad0fef093',
                                'questionTitleUuid': '',
                                'subjectId': 2,
                                'qForms': 2,
                                'questionType': 1,
                                'showType': '1',
                                'difficulty': 50,
                                'translationId': 0,
                                'estimatesTime': 90,
                                'score': 0,
                                'priority': 0,
                                'translation': '',
                                'articleTitle': '',
                                'content': {
                                    'content': '<p style="text-align:left">若一个数的正平方根为a\uFF0C立方根为b\uFF0C则下列说法正确的是\uFF08\u3000\u3000\uFF09</p>',
                                    'type': 3,
                                    'showType': 1,
                                    'image': [],
                                    'hearing': [{
                                            'sourceUuid': '1dde95081dd99094b6b4e7996557b486',
                                            'subjectId': 2,
                                            'type': 200,
                                            'source': 'http://media1.classba.cn/MC药材-二人饮酒醉2.mp3',
                                            'remark': 'FTP导入',
                                            'name': 'MC药材-二人饮酒醉2.mp3',
                                            'realName': 'MC药材-二人饮酒醉2.mp3',
                                            'status': 2,
                                            'created': '2019-07-24 19:55:11'
                                        }],
                                    'video': []
                                },
                                'options': [
                                    {
                                        'key': 'A',
                                        'content': '<p style="text-align:left">a\uFF1Eb</p>',
                                        'type': 3,
                                        'showType': 1,
                                        'image': [],
                                        'hearing': [],
                                        'video': [],
                                        'reason': []
                                    },
                                    {
                                        'key': 'B',
                                        'content': '<p style="text-align:left">a\uFF1Cb</p>',
                                        'type': 3,
                                        'showType': 1,
                                        'image': [],
                                        'hearing': [],
                                        'video': [],
                                        'reason': []
                                    },
                                    {
                                        'key': 'C',
                                        'content': '<p style="text-align:left">a=b</p>',
                                        'type': 3,
                                        'showType': 1,
                                        'image': [],
                                        'hearing': [],
                                        'video': [],
                                        'reason': []
                                    },
                                    {
                                        'key': 'D',
                                        'content': '<p style="text-align:left">都有可能</p>',
                                        'type': 3,
                                        'showType': 1,
                                        'image': [],
                                        'hearing': [],
                                        'video': [],
                                        'reason': []
                                    }
                                ],
                                'answer': 'B',
                                'analyze': [{
                                        'title': '<p style="text-align:left">根据题意可知这个数是正数\uFF0C对这个正数的取值进行讨论\uFF0E</p>',
                                        'content': [],
                                        'image': [],
                                        'video': [],
                                        'type': 3,
                                        'showType': 1
                                    }],
                                'prompt': [''],
                                'hearReading': '',
                                'articleSource': '',
                                'wordSize': 0,
                                'questionSource': [],
                                'questionTypeName': '单选题',
                                'knowledge': [
                                    {
                                        'tagId': 21471,
                                        'tagCode': 'c050104',
                                        'tagName': '立方根',
                                        'position': 21471
                                    },
                                    {
                                        'tagId': 22478,
                                        'tagCode': 'c050104_DL',
                                        'tagName': '立方根_DL',
                                        'position': 22478
                                    }
                                ],
                                'usedType': [{
                                        'tagId': 441,
                                        'tagCode': '1',
                                        'tagName': '1.练习题',
                                        'position': 441
                                    }],
                                'module': [
                                    {
                                        'tagId': 490,
                                        'tagCode': '2',
                                        'tagName': '2.巩固学习',
                                        'position': 490
                                    },
                                    {
                                        'tagId': 495,
                                        'tagCode': '7',
                                        'tagName': '7.高效学习',
                                        'position': 495
                                    }
                                ],
                                'factors': [
                                    {
                                        'tagId': 2024,
                                        'tagCode': 'gsn50',
                                        'tagName': '数感直觉能力',
                                        'position': 2024
                                    },
                                    {
                                        'tagId': 2025,
                                        'tagCode': 'gsn51',
                                        'tagName': '运算能力',
                                        'position': 2025
                                    }
                                ],
                                'reason': [],
                                'thoughts': [],
                                'methods': [],
                                'knowledgeVice': [],
                                'midFinalTerm': [],
                                'prefer': []
                            }]
                    },
                    {
                        time: 180,
                        text: '这是 3 分钟',
                        question: [{
                                'questionUuid': '7814acdf4b081109f1bfe477fe86982b',
                                'questionTitleUuid': '',
                                'subjectId': 2,
                                'qForms': 2,
                                'questionType': 1,
                                'showType': '1',
                                'difficulty': 20,
                                'translationId': 0,
                                'estimatesTime': 40,
                                'score': 0,
                                'priority': 0,
                                'translation': '',
                                'articleTitle': '',
                                'content': {
                                    'content': '<p style="text-align:left">下列说法正确的是()</p>',
                                    'type': 3,
                                    'showType': 1,
                                    'image': [],
                                    'hearing': [{
                                            'sourceUuid': '8f5998066c237cc0024c1e2c02666b1c',
                                            'subjectId': 2,
                                            'type': 200,
                                            'source': 'http://uploads.classba.cn/audio/a97af4a2e1951da1969a9ebfcd893347.mp3',
                                            'remark': '',
                                            'name': '最后我们没在一起',
                                            'realName': 'audio/a97af4a2e1951da1969a9ebfcd893347.mp3',
                                            'status': 2,
                                            'created': '2019-07-08 20:07:28'
                                        }],
                                    'video': []
                                },
                                'options': [
                                    {
                                        'key': 'A',
                                        'content': '<p style="text-align:left">\\[\\sqrt 9 \\]的平方根是\xB13</p>',
                                        'type': 3,
                                        'showType': 1,
                                        'image': [],
                                        'hearing': [],
                                        'video': [],
                                        'reason': []
                                    },
                                    {
                                        'key': 'B',
                                        'content': '<p style="text-align:left">\\[ - {a^2}\\]一定没有平方根</p>',
                                        'type': 3,
                                        'showType': 1,
                                        'image': [],
                                        'hearing': [],
                                        'video': [],
                                        'reason': []
                                    },
                                    {
                                        'key': 'C',
                                        'content': '<p style="text-align:left">0.9的平方根是\xB10.3</p>',
                                        'type': 3,
                                        'showType': 1,
                                        'image': [],
                                        'hearing': [],
                                        'video': [],
                                        'reason': []
                                    },
                                    {
                                        'key': 'D',
                                        'content': '<p style="text-align:left">\\[{a^2} +1\\]一定有平方根</p>',
                                        'type': 3,
                                        'showType': 1,
                                        'image': [],
                                        'hearing': [],
                                        'video': [],
                                        'reason': []
                                    }
                                ],
                                'answer': 'C',
                                'analyze': [{
                                        'title': '',
                                        'content': [],
                                        'image': [],
                                        'video': [],
                                        'type': 3,
                                        'showType': 1
                                    }],
                                'prompt': [''],
                                'hearReading': '',
                                'articleSource': '',
                                'wordSize': 0,
                                'questionSource': [],
                                'questionTypeName': '单选题',
                                'knowledge': [
                                    {
                                        'tagId': 21468,
                                        'tagCode': 'c050101',
                                        'tagName': '平方根',
                                        'position': 21468
                                    },
                                    {
                                        'tagId': 22477,
                                        'tagCode': 'c050101_DL',
                                        'tagName': '平方根_DL',
                                        'position': 22477
                                    }
                                ],
                                'usedType': [{
                                        'tagId': 441,
                                        'tagCode': '1',
                                        'tagName': '1.练习题',
                                        'position': 441
                                    }]
                            }]
                    }
                ];
                this.highlightData = res;
                this.sortMarkersList();
            }
        },
        {
            key: 'initHighlights',
            value: function initHighlights() {
                var _this = this;
                this.player.on('durationchange', function () {
                    if (_this.player.video.duration !== 1 && _this.player.video.duration !== Infinity) {
                        if (_this.player.options.highlight) {
                            var highlights = document.querySelectorAll('.dplayer-highlight');
                            [].slice.call(highlights, 0).forEach(function (item) {
                                _this.player.template.playedBarWrap.removeChild(item);
                            });
                            for (var i = 0; i < _this.highlightData.length; i++) {
                                if (!_this.highlightData[i].text || !_this.highlightData[i].time) {
                                    continue;
                                }
                                var p = document.createElement('div');
                                p.classList.add('dplayer-highlight');
                                p.style.left = _this.highlightData[i].time / _this.player.video.duration * 100 + '%';
                                p.innerHTML = '<span class="dplayer-highlight-text">' + _this.highlightData[i].text + '</span>';
                                _this.player.template.playedBarWrap.insertBefore(p, _this.player.template.playedBarTime);
                            }
                        }
                    }
                });
            }
        },
        {
            key: 'highlightListener',
            value: function highlightListener() {
                var _this2 = this;
                var updateInfo = function updateInfo() {
                    if (!_this2.highlightData.length) {
                        return;
                    }
                    var getNextMarkerTime = function getNextMarkerTime(index) {
                        if (index < _this2.highlightData.length - 1) {
                            return _this2.highlightData[index + 1].time;
                        }
                        return _this2.player.video.duration;
                    };
                    var currentTime = _this2.player.video.currentTime;
                    _this2.newMarkerIndex = _this2.NULL_INDEX;
                    if (_this2.currentMarkerIndex !== _this2.NULL_INDEX) {
                        _this2.nextMarkerTime = getNextMarkerTime(_this2.currentMarkerIndex);
                        if (currentTime >= _this2.highlightData[_this2.currentMarkerIndex].time && currentTime < _this2.nextMarkerTime) {
                            return;
                        }
                        if (_this2.currentMarkerIndex === _this2.highlightData.length - 1 && currentTime === _this2.player.video.duration) {
                            return;
                        }
                    }
                    if (currentTime < _this2.highlightData[0]) {
                        _this2.newMarkerIndex = _this2.NULL_INDEX;
                    } else {
                        for (var i = 0; i < _this2.highlightData.length; i++) {
                            _this2.nextMarkerTime = getNextMarkerTime(i);
                            if (currentTime >= _this2.highlightData[i].time && currentTime < _this2.nextMarkerTime) {
                                _this2.newMarkerIndex = i;
                                break;
                            }
                        }
                    }
                    if (_this2.newMarkerIndex !== _this2.currentMarkerIndex) {
                        if (_this2.newMarkerIndex !== _this2.NULL_INDEX) {
                            _this2.question = _this2.highlightData[_this2.newMarkerIndex].question[0];
                            _this2.show();
                            _this2.initHighlightQuestionPanel();
                            _this2.currentMarkerIndex++;
                        }
                        _this2.currentMarkerIndex = _this2.newMarkerIndex;
                    }
                };
                this.player.on('timeupdate', updateInfo);
            }
        },
        {
            key: 'initHighlightQuestionPanel',
            value: function initHighlightQuestionPanel() {
                console.log('adsasd-', this.question);
                var question = this.question;
                var highlightPanelContentEl = '<div class="yplayer-question-content"><div class="yplayer-questionn-title">'.concat(question.content.content, '</div><div class="yplayer-answer-area"><div class="yplayer-answer-options"><div class="yplayer-answer-option-row"><div data-keys="A" class="yplayer-answer-option"><div data-keys="A" class="yplayer-options"><div data-keys="A" class="yplayer-keys">A</div>was running... when</div></div><div data-keys="B" class="yplayer-answer-option"><div data-keys="B" class="yplayer-options"><div data-keys="B" class="yplayer-keys">B</div>runs ... when</div></div></div><div class="yplayer-answer-option-row"><div data-keys="C" class="yplayer-answer-option"><div data-keys="C" class="yplayer-options"><div data-keys="C" class="yplayer-keys">C</div>was running ... while</div></div><div data-keys="D" class="yplayer-answer-option"><div data-keys="D" class="yplayer-options"><div data-keys="D" class="yplayer-keys">D</div>ran ... while</div></div></div></div></div></div>');
                var opEl = ' <div class="yplayer-op-content">' + '<div class="yplayer-op-tips answer-wrong">' + icons.tips + '<div class="yplayer-op-tips-title">不太对哦\uFF5E</div>' + '<div class="yplayer-op-tips-content">再努力想想\uFF0C这个知识点很简单的哦\uFF5E</div>' + '<div class="yplayer-op-tips-btns">' + '<div class="yplayer-op-tips-btn retry">再试一次</div>' + '<div class="yplayer-op-tips-btn replay">回看视频</div>' + '<div class="yplayer-op-tips-btn abandon">暂时放弃</div>' + '</div>' + '<div class="yplayer-op-tips-triangle"></div>' + '</div>' + '        <div class="yplayer-op-tips answer-right">' + '        <div class="answer-status">' + icons.isright + '</div>' + '           <div class="tips-answer-content">' + '            <div class="tips-title">答对啦\uFF5E</div>' + '            <div class="tips-content">接下来继续看视频哦\uFF5E</div>' + '           </div>' + '            <div class="yplayer-op-tips-triangle"></div>' + '        </div>' + '        <button class="op-btn op-review-video">观看视频</button>' + '        <button class="op-btn op-submit">提交</button>' + '    </div>';
                this.player.template.questionPanel.innerHTML = ''.concat(highlightPanelContentEl).concat(opEl);
                this.initQuestionEvents();
                this.initSubmitEvents();
                this.initTipsEvents();
            }
        },
        {
            key: 'initQuestionEvents',
            value: function initQuestionEvents() {
                var _this3 = this;
                this.selectedOption = [];
                this.player.template.questionPanel.selectList = this.player.template.questionPanel.querySelector('.yplayer-answer-options');
                var optionSelect = function optionSelect(e) {
                    var selectEls = document.querySelectorAll('.yplayer-answer-option');
                    console.log({
                        selectEls: selectEls,
                        e: e
                    });
                    _this3.selectedOption = [];
                    Array.prototype.slice.call(selectEls).forEach(function (item, index) {
                        console.log({ item: item });
                        item.classList.remove('selected');
                    });
                    e.target.parentNode.classList.add('selected');
                    _this3.selectedOption.push(e.target.dataset.keys);
                };
                this.player.template.questionPanel.selectList.addEventListener('click', optionSelect);
            }
        },
        {
            key: 'initSubmitEvents',
            value: function initSubmitEvents() {
                var _this4 = this;
                this.selectedOption = [];
                this.player.template.questionPanel.selectList = this.player.template.questionPanel.querySelector('.yplayer-answer-options');
                var optionSelect = function optionSelect(e) {
                    var selectEls = document.querySelectorAll('.yplayer-answer-option');
                    console.log({
                        selectEls: selectEls,
                        e: e
                    });
                    _this4.selectedOption = [];
                    Array.prototype.slice.call(selectEls).forEach(function (item, index) {
                        console.log({ item: item });
                        item.classList.remove('selected');
                    });
                    e.target.parentNode.classList.add('selected');
                    _this4.selectedOption.push(e.target.dataset.keys);
                };
                this.player.template.questionPanel.selectList.addEventListener('click', optionSelect);
                this.player.template.questionPanel.OpEl = this.player.template.questionPanel.querySelector('.yplayer-op-content');
                this.player.template.questionPanel.Submit = this.player.template.questionPanel.querySelector('.op-submit');
                var submitEvent = function submitEvent() {
                    _this4.player.template.questionPanel.Submit.disabled = 'true';
                    console.log(_this4.selectedOption[0], _this4.question.answer);
                    if (_this4.selectedOption[0] == _this4.question.answer) {
                        _this4.player.template.questionPanel.OpEl.classList.add('is-right');
                    } else {
                        _this4.player.template.questionPanel.OpEl.classList.add('is-wrong');
                    }
                };
                this.player.template.questionPanel.Submit.addEventListener('click', submitEvent);
            }
        },
        {
            key: 'initTipsEvents',
            value: function initTipsEvents() {
                var _this5 = this;
                this.player.template.questionPanel.retry = this.player.template.questionPanel.querySelector('.retry');
                this.player.template.questionPanel.replay = this.player.template.questionPanel.querySelector('.replay');
                this.player.template.questionPanel.abandon = this.player.template.questionPanel.querySelector('.abandon');
                this.player.template.questionPanel.retry.addEventListener('click', function () {
                    _this5.player.template.questionPanel.OpEl.classList.remove('is-wrong');
                    _this5.player.template.questionPanel.Submit.disabled = '';
                });
                this.player.template.questionPanel.abandon.addEventListener('click', function () {
                    _this5.hide();
                });
                this.player.template.questionPanel.replay.addEventListener('click', function () {
                    if (_this5.currentMarkerIndex == 0) {
                        _this5.player.seek(0);
                    } else {
                        var prevTime = _this5.highlightData[_this5.currentMarkerIndex - 1].time + 0.5;
                        _this5.player.seek(prevTime);
                    }
                    _this5.hide();
                });
            }
        },
        {
            key: 'hide',
            value: function hide() {
                this.highlightEl.classList.add('yplayer-shade-hide');
                this.player.container.classList.remove('yplayer-highlight-visible');
                this.player.video.play();
            }
        },
        {
            key: 'show',
            value: function show() {
                this.highlightEl.classList.remove('yplayer-shade-hide');
                this.player.container.classList.add('yplayer-highlight-visible');
                this.player.template.questionPanel.classList.add('animated');
                this.player.template.questionPanel.classList.add('slideInUp');
                this.player.template.questionPanel.classList.add('faster');
                this.player.video.pause();
            }
        },
        {
            key: 'toggle',
            value: function toggle() {
                if (this.highlightEl.classList.contains('yplayer-shade-hide')) {
                    this.show();
                } else {
                    this.hide();
                }
            }
        },
        {
            key: 'sortMarkersList',
            value: function sortMarkersList() {
                this.highlightData.sort(function (a, b) {
                    return a.time - b.time;
                });
                console.log(this.highlightData);
            }
        },
        {
            key: 'destroy',
            value: function destroy() {
                this.player.template.questionPanel.innerHTML = '';
            }
        }
    ]);
    return Interaction;
}();
export default Interaction;